/**
 * WhatsApp template reporting feature flag.
 * Set REACT_APP_USE_WHATSAPP_REPORTING=false to fall back to legacy mca-bot aggregates.
 */
export const USE_WHATSAPP_REPORTING =
  process.env.REACT_APP_USE_WHATSAPP_REPORTING !== 'false';

export function formatReportingDate(date) {
  if (!date) return '';
  if (typeof date === 'string') return date;
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getDefaultReportingDateRange() {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(endDate.getDate() - 6);
  return { startDate, endDate };
}
